import Overview from './overview.vue';
import MobFull from '@rebuild/materials/shared/announcement/mobile/FullIndex.vue';

export const componentMap = {
	overview: Overview,
	'mob-full': MobFull
}; 